import { createStore, compose, applyMiddleware } from 'redux'
import { middleware as beesMiddleware } from 'redux-bees'
import thunk from 'redux-thunk'
import createRootReducer from './reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default createStore(createRootReducer(), composeEnhancers(applyMiddleware(thunk, beesMiddleware())))
